import React from 'react';
import { Link } from 'react-router-dom';

import { ButtonWrapper, Container, ErrorText } from './ConsentHTML.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { utils } from 'kb-shared';
import { getReturnBackRoute } from 'screens/InformedConsent/ConsentStateManager.utils';

import { ConsentHTMLErrorProps } from './ConsentHTMLError.types';

const { KBContacts } = utils;

export const ConsentHTMLError = ({ text, link }: ConsentHTMLErrorProps) => {
  const returnBackRoute = getReturnBackRoute();
  const buttonText = text ?? returnBackRoute.text;
  const buttonLink = link ?? returnBackRoute.pathname;

  return (
    <Container>
      <ErrorText>
        Sorry, we&apos;re unable to load this form.
        <br />
        Please try again, or contact us at{' '}
        <a className="link" href={`mailto:${KBContacts.navigatorEmail}`}>
          {KBContacts.navigatorEmail}
        </a>
        .
      </ErrorText>
      {buttonText && buttonLink && (
        <Link to={buttonLink}>
          <ButtonWrapper>
            <Button label={buttonText} category="primary" size="lg" fullWidth />
          </ButtonWrapper>
        </Link>
      )}
    </Container>
  );
};

export default ConsentHTMLError;
